import clsx from "clsx";
import { X } from "lucide-react";
import { SelectOption } from "../control/types";
import type { ControlSize } from "../types";
import { Options } from "./types";

interface SelectValueProps<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
> {
  size?: ControlSize;
  isMulti: IsMulti | undefined;
  hasInputValue: boolean;
  selectedValues: Options<Option>;
  disabled: boolean | undefined;
  removeValue: (key: string) => void;
  defaultOptionId?: string;
}

const SelectValue = (props: Readonly<SelectValueProps>) => {
  const {
    isMulti,
    hasInputValue,
    selectedValues,
    disabled,
    size = "md",
    removeValue,
    defaultOptionId,
  } = props;

  const showSingleValue = !hasInputValue && !!selectedValues.length;

  return (
    <>
      {isMulti
        ? selectedValues.map((value) => (
            <div
              key={value.id}
              className="inline-flex max-w-[calc(100%-0.375rem)] min-w-0 bg-gunmetal-50 me-1 rounded-sm items-center cursor-default"
            >
              <div
                className={clsx("min-w-0 truncate text-xs text-gunmetal-600", {
                  "px-1 py-0": size !== "sm",
                })}
                title={value.label}
              >
                {value.label}
              </div>
              {!disabled && value.id !== defaultOptionId && (
                <X
                  className={clsx("shrink-0 cursor-pointer text-gunmetal-600", {
                    "hover:bg-gunmetal-100 rounded-e-sm transition-[background]":
                      !disabled,
                    "size-4": size === "sm",
                    "p-1": size !== "sm",
                  })}
                  onClick={
                    disabled
                      ? undefined
                      : (e) => {
                          e.stopPropagation();
                          removeValue(value.id);
                        }
                  }
                />
              )}
            </div>
          ))
        : showSingleValue && (
            <div style={{ gridArea: "1/1/2" }} className="truncate">
              {selectedValues[0].label}
            </div>
          )}
    </>
  );
};

export default SelectValue;
